/**
 * Format price based on currency
 * For THB: remove decimal places
 * For USD: keep 2 decimal places
 */
export function formatPrice(price: number, currency: string): string {
  if (currency === 'thb') {
    return Math.floor(price).toString();
  } else {
    return price.toFixed(2);
  }
}

/**
 * Format price with currency symbol
 * For THB: ฿100 (no decimal)
 * For USD: $10.99 (with decimal)
 */
export function formatPriceWithSymbol(price: number, currency: string): string {
  const symbol = currency === 'thb' ? '฿' : '$';
  return symbol + formatPrice(price, currency);
} 